const configData = `
    data
    id
    publicAccess
`;

export default configData;
